import React from 'react'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'


export default (props) => {
    return (
        <Styles>
            <Container fluid>
                {props.children}
            </Container>
        </Styles>
    )
}



const Styles = styled.div`
.container-fluid{
    padding: 0px 0px 0px 0px;
}
`